export enum DataSourceProperty {
  UNIQUE_KEY_SETS = 'unique.key.sets',
}
